<template>
  <div v-if="isShow && !isTrial && !removeAlert" class="trial-tooltip-plan">
    <template>
      <img class="info-icon-small" src="../assets/info_icon.svg" />
      <div class="plan-info-center" v-html="content"></div>
      <div class="plan-right">
        <router-link
          :to="{
            name: 'Pricing'
          }"
        >
          {{ $t("generals.upgrade") }}</router-link
        >
        <!-- <div @click="onClose(page)" class="close-icon">
          <img src="../assets/close_icon.svg" />
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { mutations } from "@/store/account/types";
import { PLAN_NO } from "@/contants/plan";
export default {
  name: "LimitationPublishPage",
  props: {
    page: {
      type: String
    }
  },

  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo,
      limitationAlert: state => state.account.limitationAlert,
      publishedPagesCountStore: state => state.page.publishedPage
    }),

    limitNumberPagePublish() {
      const planLimitation = this.shopInfo?.developmentStore ? this.shopInfo?.planLimitation[this.shopInfo?.planDevelopmentStore] : this.shopInfo?.planLimitation[this.shopInfo?.plan];
      if (planLimitation) {
        if (this.page === "productpages") {
          return planLimitation?.pagePublish?.nbOfPublishedProductPage || 0;
        } else if (this.page === "articlepages") {
          return planLimitation?.pagePublish?.nbOfPublishedArticlePage || 0;
        }
      }
      return 0;
    },
    isTrial() {
      return this.shopInfo?.plan === PLAN_NO.TRIAL || this.shopInfo?.plan === PLAN_NO.TRIAL2022;
    },
    removeAlert() {
      return this.limitationAlert[this.page];
    },
    totalPublished() {
      if (this.page === "productpages") {
        return this.shopInfo.publishedProductPagesCount + (this.publishedPagesCountStore[this.page] || 0);
      } else if (this.page === "articlepages") {
        return this.shopInfo.publishedArticlePagesCount + (this.publishedPagesCountStore[this.page] || 0);
      }
      return 0;
    },
    isShow() {
      if (this.page === "productpages") {
        return this.limitNumberPagePublish <= this.shopInfo.publishedProductPagesCount + (this.publishedPagesCountStore[this.page] || 0);
      } else if (this.page === "articlepages") {
        return this.limitNumberPagePublish <= this.shopInfo.publishedArticlePagesCount + (this.publishedPagesCountStore[this.page] || 0);
      }
      return false;
    },
    content() {
      return this.$t("limitation.publishPage", { value: `${this.totalPublished}/${this.limitNumberPagePublish}` });
    }
  },

  methods: {
    ...mapMutations("account", {
      onClose: mutations.UPDATE_LIMITATION_SUB_PAGE_ALERT
    })
  }
};
</script>

<style scoped lang="scss">
.trial-tooltip-plan {
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  background-color: #D8E1FF;
  border-radius: 3px;
  margin-top: 24px;
  margin-bottom: -8px;
  &.trial-warning {
    background-color: #fed571;
  }
  &.sub-page {
    margin-bottom: -4px;
  }
  .info-icon {
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    margin-right: 16px;
    img {
      width: 21px;
      height: 21px;
      &.warning {
        height: 19.204177856445312px;
        width: 21.86865997314453px;
      }
    }
  }
  .info-trial-container {
    font-family: "Inter";
    font-style: normal;
    color: #212121;
    flex: 1;
    .info-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 4px;
    }

    .info-desc {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      max-width: 573px;
      margin-bottom: 8px;
    }
    a {
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #3c67ff;
      cursor: pointer;
    }
  }
  .plan-right {
    a {
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #3c67ff;
      cursor: pointer;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    display: flex;
    align-items: center;
  }
  .plan-info-center {
    display: flex;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #212121;
  }
  .info-icon-small {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .close-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 11px;
      height: 11px;
    }
  }
}
</style>
